var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex bg-light rounded p-1"},[_c('span',{staticClass:"time text-end mr-1"},[_vm._v(_vm._s(_vm.time))]),_c('span',{staticClass:"label flex-grow-1"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }